const MANAGE_ORDER_CANCEL_LOADING = "MANAGE_ORDER_CANCEL_LOADING";
const MANAGE_ORDER_CANCEL_SUCCESS = "MANAGE_ORDER_CANCEL_SUCCESS";
const MANAGE_ORDER_CANCEL_ERROR = "MANAGE_ORDER_CANCEL_ERROR";
export {
  MANAGE_ORDER_CANCEL_LOADING,
  MANAGE_ORDER_CANCEL_SUCCESS,
  MANAGE_ORDER_CANCEL_ERROR,
};
